import { render, staticRenderFns } from "./PropertyTypeSelect.vue?vue&type=template&id=32b05ee8&"
import script from "./PropertyTypeSelect.vue?vue&type=script&lang=js&"
export * from "./PropertyTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports